<template>
  <div class="page">
    <div class="top-logo" @click="$gopage('index')">
      <img src="~images/logo-login.png">
      <span>朗朗书声</span>
    </div>
    <div class="container">
      <div class="cont">
        <div class="login-box">
          <div class="title">
            <h2>老师，在这里修改您的密码</h2>
            <div class="tip">朗朗书声语文朗读教学平台（诵读资源库）</div>
          </div>
          <div class="form-box">
            <div class="form-item">
              <FInput ref="mobile" v-model="formData.mobile" :maxlength="11" type="text" placeholder="请输入手机号" />
            </div>
            <div class="form-item form-item-vcode">
              <div class="item-code">
                <FInput :showDel="false" v-model="formData.code" ref="code" :maxlength="6" type="text" placeholder="请输入6位短信验证码">
                  <button class="btn btn-code" :class="{disabled: !canSend}" v-text="btnText" @click="getCode"></button>
                </FInput>
              </div>
            </div>
            <div class="form-item">
              <FInput ref="pwd" v-model="formData.pwd" :maxlength="16" type="password" placeholder="设置您的密码（6-16位字母、数字、无空格）" />
            </div>
            <button class="btn btn-act btn-confirm" @click="submit" :class="{'btn-disabled': !isCanClick}">确认</button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="copy">Copyright @ 2020 朗朗书声 All Right Reserved 京ICP备19040061号</div>
      <div class="wj">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040926" style="display:inline-block;">
          <img src="~images/icon-wj.png" style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px;">京公网安备 11010502040926号</p>
        </a>
      </div>
    </div>
    <CodeValid ref="codeValid" @confirm="codeConfirm" v-model="showValidCode" />
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

import FInput from 'base/input/index';
import CodeValid from 'business/CodeValid';
import mixin_user from 'mixin/user';
import Vue from 'vue';
import md5 from 'md5';

export default {
  components: {
    FInput,
    CodeValid
  },
  mixins: [mixin_user],
  computed: {
    ...mapGetters([
      'getUserInfo'
    ])
  },
  data() {
    return {
      isCanClick: false,
      smsType: 2,
      showSuccess: true,
      formData: {
        mobile: '',
        code: '',
        pwd: '',
        captcha: ''
      }
    }
  },
  watch: {
    formData: {
      handler(newVal) {
        if (newVal.mobile && newVal.code && newVal.pwd && newVal.pwd.length > 5) {
          this.isCanClick = true;
        } else {
          this.isCanClick = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    goLogin() {
      this.$gopage('login')
    },
    async submit() {
      if (!this.isCanClick) {
        return;
      }
      const formData = this.formData;
      if (!this.isCanClick) {
        return;
      }
      const config = [{
        id: 'mobile',
        rule: {
          required: {
            message: '请输入手机号码'
          },
          mobile: {
            message: '请输入正确的手机号码'
          }
        }
      }, {
        id: 'code',
        rule: {
          required: {
            message: '请输入验证码'
          }
        }
      }, {
        id: 'pwd',
        rule: {
          required: {
            message: '请输入密码'
          },
          maxlength: {
            message: '密码长度不能大于16个字符',
            param(v) {
              return v.length <= 16;
            }
          },
          minlength: {
            message: '密码长度不能小于6个字符',
            param(v) {
              return v.length >= 6;
            }
          },
          char: {
            message: '请输入6-16位字母、数字、无空格',
            param(v) {
              return v && /^[a-zA-Z0-9]+$/.test(v)
            }
          }
        }
      }];
      let { result } = await this.$checkForm(config, formData);
      if (!result) {
        return;
      }
      let query = this.$route.query;
      this.$loading.show();
      const params = {
        mobile: formData.mobile,
        code: formData.code,
        pwd: formData.pwd
      };
      params.pwd = md5(params.pwd);
      const res = await this.$post('/passport/findpwd.json', params);
      if (res.status == 200) {
        this.formData.mobile = '';
        this.formData.pwd = '';
        this.formData.code = ''
        this.$toast('密码重置成功,请您重新登录!');
        setTimeout(() => {
          this.$gopage('login')
        }, 3000)
      } else {
        this.$toast(res.message);
      }
      this.$loading.hide();
    }
  }
}
</script>
<style lang="less" scoped>
@import '~styles/user/index.less';
</style>